export default "__VITE_ASSET__179a0a6b__"